import {
  PerimetriDestinatari,
  PolicyService,
} from './../../../../../services/policy/policy.service';
import { Component, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-crea-destinatari-policy',
  templateUrl: './dialog-crea-destinatari-policy.component.html',
  styleUrls: ['./dialog-crea-destinatari-policy.component.scss'],
  standalone: false,
})
export class DialogCreaDestinatariPolicyComponent {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public formDestinatarioPolicy = new FormGroup({
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),

    descrizione: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),
    lineaGuidaDestinatario: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),
  });

  constructor(
    public dialogRef: MatDialogRef<DialogCreaDestinatariPolicyComponent>,
    private readonly policyService: PolicyService,
    private readonly utilityService: UtilityService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      idPolicySostenibilita: string;
      destinatarioPolicy: any;
    },
  ) {}

  ngAfterViewInit(): void {
    if (this.data?.destinatarioPolicy) {
      Object.keys(this.data.destinatarioPolicy).forEach((value, index, array) => {
        this.formDestinatarioPolicy.get(value)?.setValue(this.data.destinatarioPolicy[value]);
      });
    }
  }

  public salva() {
    if (this.formDestinatarioPolicy.valid) {
      this.spinnerOver.show();

      const objDestinatario: PerimetriDestinatari = {
        chiaveElemento: 'destinatario',
        ...this.formDestinatarioPolicy.getRawValue(),
      };

      if (this.data.idPolicySostenibilita) {
        this.policyService
          .putDestinatariEffimeri(this.data.idPolicySostenibilita, objDestinatario)
          .pipe(
            finalize(() => {
              this.spinnerOver.hide();
              this.dialogRef.close();
            }),
          )
          .subscribe({
            next: () => {
              this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
                duration: 2000,
                panelClass: ['success-snackbar'],
              });
              this.dialogRef.close();
            },
            error: (err: any) => {
              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: err.error.message,
                bottoni: [{ nome_btn: 'Chiudi' }],
              });
            },
          });
      } else {
        if (this.data.destinatarioPolicy?.id) {
          this.policyService
            .putDestinatariPolicy(this.data.destinatarioPolicy?.id, objDestinatario)
            .pipe(finalize(() => this.spinnerOver.hide()))
            .subscribe({
              next: () => {
                this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
                  duration: 2000,
                  panelClass: ['success-snackbar'],
                });
                this.dialogRef.close();
              },
              error: (err: any) => {
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [{ nome_btn: 'Chiudi' }],
                });
              },
            });
        } else {
          this.policyService
            .postDestinatariPolicy(objDestinatario)
            .pipe(finalize(() => this.spinnerOver.hide()))
            .subscribe({
              next: () => {
                this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
                  duration: 2000,
                  panelClass: ['success-snackbar'],
                });
                this.dialogRef.close();
              },
              error: () => {
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: 'Errore nel salvataggio ',
                  bottoni: [{ nome_btn: 'Chiudi' }],
                });
              },
            });
        }
      }
    } else {
      Object.values(this.formDestinatarioPolicy.controls).forEach((control) => {
        control.markAsTouched();
      });
    }
    return null;
  }
}
